<template>
  <div class="ai-list">
    <!-- <div class="ai-creation-list">
      <div class="ai-creation-title"></div>
      <div class="creation-item" @click="openDetail" v-for="(item, index) in creationList" :key="index">{{index +1 }}&nbsp;{{ item }}</div>
    </div> -->
    <div class="ai-hot-list">
      <div class="ai-hot-title">
        <img src="../../../assets/jfrb/hot-bg.png" alt="" />
      </div>
      <!-- 获取list的length小于3条则style高度为140px,否则设el-scrollbar高度为460px -->

      <el-scrollbar
        v-if="list.length > 0"
        :style="{ height: scrollbarHeight }"
        style="overflow-x: hidden"
        ref="scrollbar"
      >
        <div class="hot-item" v-for="(item, index) in list" :key="index">
          <div class="hot-title" @click="openDetail(item)">
            {{ item.title }}
          </div>
          <div class="hot-info">
            <div>
              <span class="time">{{ item.updatetime | formatDate }}</span>
              <span class="heat"
                >热度<i>{{ parseFloat(item.degree).toFixed(2) }}</i></span
              >
            </div>
            <div>
              <span class="time">{{ item.papername | formatPaperName }}</span>
              <span class="tags" v-if="item.class1">{{ item.class1 }}</span>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div class="noData" v-else>暂无数据</div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title=""
      width="45%"
      @close="handleClose"
      :append-to-body="true"
      :lock-scroll="false"
      top="6vh"
    >
      <article-detail :articleDetail="articleDetail"></article-detail>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ArticleDetail from "@/pages/views/project/components/ArticleDetail.vue";
import { GetJfrbArticle } from "@/api/index.js";
import { formatPaperName } from "@/filters/index.js";
export default {
  filters: {
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    formatPaperName
  },
  components: {
    ArticleDetail
  },
  props: {
    hotList: {
      type: Array
    }
  },
  data() {
    return {
      dialogVisible: false,
      articleDetail: {},
      creationList: [],
      list: []
    };
  },
  watch: {
    hotList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.list = newVal;
        }
      },
      deep: true
    }
  },
  computed: {
    scrollbarHeight() {
      return this.list.length < 3 ? "180px" : "460px";
    }
  },
  mounted() {},
  methods: {
    openDetail(item) {
      console.log("🚀 ~ openDetail ~ item:", item);
      GetJfrbArticle({ id: item.articlesequenceid })
        .then((res) => {
          if (res.succeed) {
            item.contenttxt = res.data.contenttxt;
            this.articleDetail = item;
            this.dialogVisible = true;
          }
        })
        .catch((err) => {});
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-list {
  .ai-creation-list {
    background: #fff;
    margin-bottom: 20px;
    border-radius: 6px;
    .ai-creation-title {
      height: 54px;
      line-height: 54px;
      font-weight: 600;
      font-size: 20px;
      color: #222222;
      background: url("../../../assets/jfrb/creation-bg.png") no-repeat right;
    }
    .creation-item {
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      font-size: 16px;
      color: #222222;
      border-bottom: 1px solid #ebeef5;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .creation-item:last-child {
      border: none;
    }
  }
  .ai-hot-list {
    background: #fff;
    margin-bottom: 20px;
    border-radius: 6px;
    overscroll-behavior: contain;
    .ai-hot-title {
      height: 54px;
      line-height: 54px;
      font-weight: 600;
      font-size: 20px;
      color: #222222;
      // background: url("../../../assets/jfrb/hot-bg.png") no-repeat right;
      cursor: pointer;
    }
    .hot-item {
      padding: 10px 15px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border: none;
        padding-bottom: 100px;
      }
      .hot-title {
        font-weight: 400;
        font-size: 14px;
        color: #333;
        text-overflow: -o-ellipisis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 4px;
        cursor: pointer;
        &:hover {
          color: var(--brand);
        }
      }
      .hot-info {
        font-size: 12px;
        color: #7a7a7a;
        > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
          .tags {
            background: rgba(62, 157, 211, 0.1);
            padding: 1px 4px;
            color: var(--brand);
            font-size: 12px;
          }
          .time {
            flex: 1;
          }
          .heat {
            i {
              font-style: normal;
              font-weight: bold;
              font-size: 14px;
              color: #fe2d46;
              margin-left: 4px;
            }
          }
        }
      }
    }
  }
}
.noData {
  color: var(--text-3);
  min-height: 100px;
  max-height: 460px;
  text-align: center;
  margin-top: 50px;
}
::v-deep .el-scrollbar__wrap {
  overscroll-behavior: contain;
}
</style>
